/**
 * Utility to construct correct media URLs for both localhost and production
 *
 * On localhost: Frontend (3000) and Backend (8000) are on different ports
 * On production: Both are served from the same domain
 */

// Get the base URL for media files
export const getMediaBaseUrl = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  if (isLocalhost) {
    // On localhost, media is served from backend port
    return 'http://localhost:8000';
  }

  // On production, media is served from the same origin
  return window.location.origin;
};

/**
 * Build a full media URL from a relative path
 * @param {string} path - The media path (e.g., "/media/profiles/image.jpg" or "media/video.mp4")
 * @returns {string} - Full URL to the media file
 */
export const buildMediaUrl = (path) => {
  if (!path) return '';

  // Already a full URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:') || path.startsWith('data:')) {
    return path;
  }

  const baseUrl = getMediaBaseUrl();

  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${baseUrl}${normalizedPath}`;
};

/**
 * Build a profile picture URL
 * @param {string} path - The profile picture path from API
 * @returns {string} - Full URL to the profile picture
 */
export const buildProfilePictureUrl = (path) => {
  return buildMediaUrl(path);
};

/**
 * Build a video URL
 * @param {string} path - The video path from API
 * @returns {string} - Full URL to the video
 */
export const buildVideoUrl = (path) => {
  return buildMediaUrl(path);
};

export default {
  getMediaBaseUrl,
  buildMediaUrl,
  buildProfilePictureUrl,
  buildVideoUrl,
};
